import React,{Component} from 'react'
import {
    Row,
    Col,
    Steps,
    Tabs,
    Table,
    Upload,
    message, Modal,Icon,Affix
} from 'antd'
import axios from 'axios'
//import DeliveryStep from '../../components/step/delivery-step'
import './order-info.less'
import {splitStr} from '../../utills/subStringUtill'
import {getOrderDetails,getOrderDelivery,getOrderTrails, baseUrl,reqFileList,getPackages} from '../../api'
import {isImageUrl} from "antd/lib/upload/utils";
import OrderFileComponent from "../../components/bus/order-file"
import OrderDeclare from '../track-edit/order-declare'
const { TabPane } = Tabs
const { Step } = Steps
//let orderId = '';
export default class OrderInfo extends Component {

    state={
        id:'',
        orderId:'',
        orderData:[],
        packageManageVos:[],  // 商品列表,
        consignorVo:{},
        deliveryPlaceVo:{},
        visible:false,
        notifyPartyVo:{},
        trailNo:'' ,//轨迹号
        deliveryTrailDo:[],
        currentStep: 0,
        fileList: [],
        boxNo:'',
        factoryNo:'',
        carNo:'',
        mobileurl:'',
    }

    getOrderDetails = async (id) => {
        let result = await getOrderDetails(id)
        if(result.code===200) {
            const orderData = result.data
            const {consignorVo,deliveryPlaceVo,notifyPartyVo,packageManageVos,boxRentStation,boxReturnStation} = orderData
            this.setState({
                consignorVo,
                deliveryPlaceVo,
                notifyPartyVo,
                orderData,
                //packageManageVos:packageManageVos,
                commitDt:orderData.commitDt,boxRentStation,boxReturnStation
            })
        }else if(result.code === 401){
            this.props.history.replace('/login')
        }

    }
    goods = async (orderId, page = 1, pageSize = 20) => {
        let result = await getPackages({orderId, pageNum: page, pageSize});
        if (result.code === 200) {
            if (result.data) {
                this.setState({
                    page,
                    pageSize,
                    total: result.data.total,
                    packageManageVos: result.data.rows,
                })
            }
        }
        else {
            message.error(result.message)
            return false;
        }
    };
    // 查询 轨迹号
    getOrderDelivery = async (id) => {
        let result = await getOrderDelivery(id)
        if(result.code===200) {
            const orderData = result.data;
            if (orderData && orderData.length > 0) {
                let boxNo = '';
                let factoryNo = '';
                let i=0,j=0;
                for (let o of orderData) {
                    if (o.boxNo) {
                        ++i;
                        boxNo = boxNo + o.boxNo + '，';
                    }
                    if (i===2 && i < result.data.length - 1) {
                        boxNo = boxNo+'...';
                        break;
                    }
                }
                for (let o of orderData) {
                    if (o.factoryNo) {
                        ++j;
                        factoryNo = factoryNo + o.factoryNo + '，';
                    }
                    if (j===2 && i < result.data.length - 1) {
                        factoryNo = factoryNo+'...';
                        break;
                    }
                }
                boxNo =splitStr(boxNo)
                factoryNo =splitStr(factoryNo)

                this.setState({
                    boxNo: boxNo,
                    factoryNo: factoryNo
                })
            }
            const {trailNo} = orderData;
            this.getOrderTrails(trailNo)
        }else{

        }
    }

    getPublicVehicle = (orderId) =>{
        axios.get(baseUrl + '/api/v1/p/orderVehicle', { // 配置对象
            params: {orderId} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                // debugger
                if (result.data && result.data.length > 0) {
                    let carNo = '';
                    for (let i = 0; i < result.data.length; i++) {
                        if (result.data[i].truckNo) { //车牌号
                            carNo = carNo + result.data[i].truckNo + '，';
                        }
                        if (i===1 && i < result.data.length - 1) {
                            carNo = carNo+'...';
                            break;
                        }
                    }
                    carNo =splitStr(carNo)

                    this.setState({
                        carNo: carNo,
                    })
                }
            } else {
                message.error(result.message)
                return false;
            }
        });
    }

    // 查询轨迹信息
    getOrderTrails = async (trailNo) => {
        if(trailNo){
            let result = await getOrderTrails(trailNo)
            if(result.code===200) {
               this.setState({
                   deliveryTrailDo:result.data
               })
            }else{

            }
        }
    }
    componentWillMount () {
        if(this.props.location.state) {
            const id = this.props.location.state.id
            const orderId = this.props.location.state.id
            this.setState({
                id,
                orderId
            })
            this.getOrderDetails(id)
           // this.goods(id);
            this.getOrderDelivery(id)
            this.getPublicVehicle(id)
            axios.get(baseUrl + '/api/v1/p/optRecord', { // 配置对象
                params: {orderId:id} // 指定请求参数
            }).then((res) => {
                var result = res.data;
                if (result.code === 200) {
                    if (result.data && result.data.length > 0) {
                        for (let i = 0; i < result.data.length; i++) {
                            let {currentStep} = this.state;
                            if (result.data[i].optType == 'collect') {
                                if (result.data[i].optDt && currentStep < 1){
                                    currentStep = 1;
                                }
                                this.setState({
                                    collectDt: result.data[i].optDt,
                                    currentStep: currentStep
                                })
                            } else if (result.data[i].optType == 'arrive') {
                                if (result.data[i].optDt && currentStep < 2){
                                    currentStep = 2;
                                }
                                this.setState({
                                    arriveDt: result.data[i].optDt,
                                    currentStep: currentStep
                                })
                            } else if (result.data[i].optType == 'declare') {
                                if (result.data[i].optDt && currentStep < 3){
                                    currentStep = 3;
                                }
                                this.setState({
                                    declareDt: result.data[i].optDt,
                                    currentStep: currentStep
                                })
                            } else if (result.data[i].optType == 'pass') {
                                if (result.data[i].optDt && currentStep < 4){
                                    currentStep = 4;
                                }
                                this.setState({
                                    passDt: result.data[i].optDt,
                                    currentStep: currentStep
                                })
                            } else if (result.data[i].optType == 'transport') {
                                if (result.data[i].optDt && currentStep < 5){
                                    currentStep = 5;
                                }
                                this.setState({
                                    transportDt: result.data[i].optDt,
                                    currentStep: currentStep
                                })
                            } else if (result.data[i].optType == 'destination') {
                                if (result.data[i].optDt && currentStep < 6){
                                    currentStep = 6;
                                }
                                this.setState({
                                    destinationDt: result.data[i].optDt,
                                    currentStep: currentStep
                                })
                            }
                        }
                    }
                }
                else {
                    message.error(result.message)
                    return false;
                }
            });
        }else{
            return
        }
    }

    setColletDt = (date) =>{
        if(date){
            this.setState({
                collectDt:date
            })
        }

    }
    render () {
        const props = {
            name: 'file',
            listType: 'picture',
            onPreview:this.handlePreview,
            disabled:true,
        };
        const columns = [
            {
                title: '唛码标记Marks',
                dataIndex: 'boxNo',
                render: text => <a>{text}</a>,
            },
            {
                title: '箱数CTNS',
                dataIndex: 'num'/*,
                render: (text, record) => (
                    <span>
                        {text}/{record.num}
                    </span>
                )*/
            },
            {
                title: '品名(中文)',
                dataIndex: 'name'
            },
            {
                title: '国内HSCode',
                dataIndex: 'hscode'
            },{
                title: '净重(Kg)',
                dataIndex: 'netWeight',
            }, {
                title: '毛重(Kg)',
                dataIndex:'grossWeight',
            }, {
                title: '体积(CBM)',
                dataIndex: 'volume',
            }, {
                title: '总价',
                dataIndex: 'totalValue',
            }, {
                title: '币制',
                dataIndex: 'currency',
            }
        ];
        const {packageManageVos,orderData} = this.state
        const destinationCityStep = "到达"+orderData.destinationCity;
        return (
            <div className='trackInfo'>
                <div className="track-info-details box-shadow margin-bootom">
                    <Row className='track-info-item'>
                        <Col span={6}>
                            <span className='label'>订单编号 : </span>
                            <span>{orderData.orderNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>企业名称: </span>
                            <span>{orderData.entName}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>起运地 : </span>
                            <span>{orderData.originCountry}</span>
                            &nbsp;&nbsp;
                            <span>{orderData.originCity}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>转关地: </span>
                            <span>{orderData.destinationStartCountry} {orderData.destinationStartCity}</span>
                        </Col>
                    </Row>
                    <Row className='track-info-item'>
                        <Col span={6}>
                            <span className='label'>目的地 : </span>
                            <span>{orderData.destinationCountry}</span>
                            &nbsp;&nbsp;
                            <span>{orderData.destinationCity}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>还箱地: </span>
                            <span>{orderData.boxReturnStation}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>收货人 : </span>
                            <span>{orderData.consignee}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>提货时间 : </span>
                            <span>{this.state.collectDt}</span>
                        </Col>
                    </Row>
                    <Row className='track-info-item'>
                        <Col span={6}>
                            <span className='label'>车牌号 : </span>
                            <span>{this.state.carNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>集装箱号 ：</span>
                            <span>{this.state.boxNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>厂封号 ：</span>
                            <span>{this.state.factoryNo}</span>
                        </Col>
                    </Row>
                </div>
                <div className='order-info box-shadow'>
                    <Row className='order-info-content'>
                        <Col span={24} className='order-info-content-left'>
                            <Tabs defaultActiveKey="1">
                                <TabPane tab="概况" key="1">
                                   <div className='general-part'>
                                      <Row className='general-part-item'>
                                          <Col span={3} className='general-part-item-title'>发货企业:</Col>
                                          <Col span={9}>{orderData.shipper}</Col>
                                           <Col span={3} className='general-part-item-title'>发货企业地址:</Col>
                                           <Col span={9}>{orderData.shipperAddr}</Col>
                                       </Row>
                                       <Row className='general-part-item'>
                                           <Col span={3} className='general-part-item-title'>境外收货方:</Col>
                                           <Col span={9}>{orderData.consignee}</Col>
                                           <Col span={3} className='general-part-item-title'>境外收货方地址:</Col>
                                           <Col span={9}>{orderData.consigneeAddr}</Col>
                                       </Row>
                                       <Row className='general-part-item'>
                                           <Col span={3} className='general-part-item-title'>联系方式:</Col>
                                           <Col span={9}>{orderData.consigneeTel}</Col>
                                       </Row>
                                       <Row className='general-part-item'>
                                           <Col span={3} className='general-part-item-title'>通知方:</Col>
                                           <Col span={9}>{orderData.notifyParty}</Col>
                                           <Col span={3} className='general-part-item-title'>通知方地址:</Col>
                                           <Col span={9}>{orderData.notifyPartyAddr}</Col>
                                       </Row>
                                       <Row className='general-part-item'>
                                           <Col span={3} className='general-part-item-title'>仓库联系人:</Col>
                                           <Col span={9}>{orderData.contact}</Col>
                                           <Col span={3} className='general-part-item-title'>仓库地点:</Col>
                                           <Col span={9}>{orderData.deliveryPlace}</Col>
                                       </Row>
                                       <Row className='general-part-item'>
                                           <Col span={3} className='general-part-item-title'>联系方式:</Col>
                                           <Col span={9}>{orderData.contactTel}</Col>
                                           <Col span={3} className='general-part-item-title'>预计提货时间:</Col>
                                           <Col span={9}>{orderData.deliveryEstimateDt}</Col>
                                       </Row>
                                       <Row className='general-part-item'>
                                           <Col span={3} className='general-part-item-title'>提货时间:</Col>
                                           <Col span={9}>{this.state.collectDt}</Col>
                                           <Col span={3} className='general-part-item-title'>集装箱数:</Col>
                                           <Col span={9}>{orderData.containerNum}</Col>
                                       </Row>
                                       <Row className='general-part-item'>
                                           <Col span={3} className='general-part-item-title'>集装箱类型:</Col>
                                           <Col span={9}>{orderData.containerType}</Col>
                                           <Col span={3} className='general-part-item-title'>班次时间:</Col>
                                           <Col span={9}>{orderData.shiftDt}</Col>
                                       </Row>
                                       <Row className='general-part-item'>
                                           <Col span={3} className='general-part-item-title'>租箱地:</Col>
                                           <Col span={9}>{this.state.boxRentStation}</Col>
                                           <Col span={3} className='general-part-item-title'>还箱地:</Col>
                                           <Col span={9}>{this.state.boxReturnStation}</Col>
                                       </Row>
                                   </div>
                                    {/*<div className="info-item-title">
                                        轨迹信息
                                    </div>
                                    <div className='tract-step-info '>
                                        <DeliveryStep {...this.props} setColletDt={this.setColletDt}/>
                                    </div>*/}
                                </TabPane>
                               {/* <TabPane tab="商品信息" key="2">
                                    <div style={{padding:'20px'}}>
                                        <Table columns={columns} bordered dataSource={packageManageVos} size="middle" pagination={{
                                            current: this.state.page,
                                            pageSize: this.state.pageSize ? this.state.pageSize : 20,
                                            total: this.state.total,
                                            pageSizeOptions: ['20', '50', '100'],
                                            showSizeChanger: true,
                                            onShowSizeChange: (page, pageSize) => {
                                                this.goods(this.state.orderId, page, pageSize);
                                            },
                                            onChange: (page, pageSize) => {
                                                this.goods(this.state.orderId, page, pageSize);
                                            },
                                        }}/>
                                    </div>

                                </TabPane>*/}
                                <TabPane tab="文件" key="3">
                                    <OrderFileComponent orderId={this.state.id} readonly={true}/>
                                </TabPane>
                                <TabPane tab="提箱单" key="4">
                                    <OrderFileComponent orderId={this.state.id} readonly={true} objectType={"box"}/>
                                </TabPane>
                                {/*<TabPane tab="报关单" key="5">
                                    <OrderDeclare orderId={this.state.id}/>
                                </TabPane>*/}
                            </Tabs>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}